// src/data/pingEvents.js
// Événements ping codifiés — modifient les stats du démon
// Déclenchés depuis la page OniTalk (quizz post-session)

export const PING_EVENTS = [

  // ── ILLUMINATIONS (boosts positifs) ──────────────────────────────────
  {
    id: "illumination",
    label: "🌟 ILLUMINATION",
    desc: "Un truc a soudainement fait sens. Tu sais pas trop pourquoi. Mais ça marche.",
    category: "growth",
    statMods: { adaptation: +8, creativity: +5, discipline: +3 },
    lore: "Le démon a vu quelque chose que les autres n'ont pas vu. Il le garde pour lui.",
    xp: 40,
  },
  {
    id: "spin_reading",
    label: "🌀 SPIN READING UNLOCKED",
    desc: "T'as commencé à lire les effets adverses avant l'impact. Tes retours deviennent dangereux.",
    category: "growth",
    statMods: { adaptation: +10, control: +6, chaos: -3 },
    lore: "Les effets cessent d'être des mystères. Ils deviennent des armes.",
    xp: 50,
  },
  {
    id: "the_zone",
    label: "⚡ DANS LA ZONE",
    desc: "T'as joué 20 minutes où chaque balle allait exactement où tu voulais. C'était démoniaque.",
    category: "growth",
    statMods: { discipline: +8, control: +8, emotion: +5, ego: +4 },
    lore: "Le démon s'est aligné. Brièvement. Mais c'était réel.",
    xp: 60,
  },
  {
    id: "footwork_click",
    label: "👣 FOOTWORK CLICK",
    desc: "Les déplacements ont commencé à s'enchaîner sans y penser. Le corps a mémorisé.",
    category: "growth",
    statMods: { adaptation: +7, aggression: +5, patience: +3 },
    lore: "Le démon se déplace maintenant comme s'il avait toujours su.",
    xp: 45,
  },
  {
    id: "backhand_awakening",
    label: "🔓 REVERS AWAKENING",
    desc: "Ton revers a fait un truc que t'avais jamais réussi avant. Intentionnellement.",
    category: "growth",
    statMods: { aggression: +6, creativity: +6, ego: +4 },
    lore: "La main gauche du démon a trouvé sa voix.",
    xp: 45,
  },
  {
    id: "mental_fortress",
    label: "🧱 MENTAL FORTRESS",
    desc: "T'as perdu les 3 premiers points et tu as pas paniqué. T'as remonté. T'as gagné.",
    category: "growth",
    statMods: { discipline: +10, emotion: -5, patience: +8, ego: +3 },
    lore: "Les murs du démon sont devenus plus épais. La rage rentre moins.",
    xp: 65,
  },
  {
    id: "serve_deception",
    label: "🎭 SERVICE TROMPERIE",
    desc: "Ton service a fait deux points directs sur des joueurs qui avaient l'air de savoir jouer.",
    category: "growth",
    statMods: { chaos: +7, creativity: +6, ego: +5 },
    lore: "Le démon a appris à mentir avec la balle.",
    xp: 50,
  },
  {
    id: "loop_discovered",
    label: "🌊 LOOP DÉCOUVERT",
    desc: "T'as sorti un lift qui t'a toi-même surpris. La balle a accéléré comme jamais.",
    category: "growth",
    statMods: { aggression: +8, creativity: +7, risk: +5 },
    lore: "La puissance cachée du démon commence à se manifester.",
    xp: 55,
  },
  {
    id: "patience_rewarded",
    label: "⏳ PATIENCE RÉCOMPENSÉE",
    desc: "T'as joué 30 échanges dans le même rally. L'adversaire a craqué avant toi.",
    category: "growth",
    statMods: { patience: +12, discipline: +6, control: +5, aggression: -3 },
    lore: "Le démon a attendu. Et l'attente a tué.",
    xp: 60,
  },
  {
    id: "adaptation_master",
    label: "🦎 CAMOUFLAGE RÉUSSI",
    desc: "T'as changé complètement de style en cours de match pour t'adapter. Et ça a marché.",
    category: "growth",
    statMods: { adaptation: +12, creativity: +6, ego: +3 },
    lore: "Le démon a plusieurs visages. Il en a montré un nouveau.",
    xp: 55,
  },

  // ── TRASH EVENTS (déblocages négatifs/chaotiques) ─────────────────────
  {
    id: "trash_tilt",
    label: "💢 FULL TILT",
    desc: "T'as tilté complètement. Genre vraiment. Tout ton jeu s'est effondré en 5 points.",
    category: "chaos",
    statMods: { emotion: +12, discipline: -8, aggression: +8, ego: +5 },
    lore: "Le démon a pris le contrôle. Ce n'était pas beau. C'était réel.",
    xp: 20,
  },
  {
    id: "trash_smash_addiction",
    label: "💥 SMASH ADDICTION",
    desc: "T'as smashé chaque balle courte. T'as mis 3 smashes dans le filet de suite. T'as recommencé.",
    category: "chaos",
    statMods: { aggression: +8, risk: +10, discipline: -6, creativity: -3 },
    lore: "La destruction appelle la destruction. Le démon ne peut pas s'en empêcher.",
    xp: 25,
  },
  {
    id: "trash_excuse_mode",
    label: "😤 EXCUSE MODE ACTIVATED",
    desc: "T'as trouvé 4 raisons différentes d'expliquer pourquoi tu perdais. Aucune c'était toi.",
    category: "chaos",
    statMods: { ego: +10, adaptation: -5, discipline: -4, emotion: +6 },
    lore: "L'univers complotait contre le démon. Encore.",
    xp: 15,
  },
  {
    id: "trash_service_yips",
    label: "🫣 SERVICE YIPS",
    desc: "T'as raté 3 services de suite. Simples. Des services que tu rates jamais.",
    category: "chaos",
    statMods: { emotion: +8, discipline: -6, ego: -4, chaos: +5 },
    lore: "Même le démon tremble parfois. Ne lui dis pas.",
    xp: 20,
  },
  {
    id: "trash_overthink",
    label: "🧠 PARALYSIS BY ANALYSIS",
    desc: "T'as tellement réfléchi à ce que tu allais jouer que t'as raté la balle.",
    category: "chaos",
    statMods: { creativity: -5, adaptation: -4, discipline: +5, emotion: +6 },
    lore: "Le démon a pensé trop fort. La balle n'attendait pas.",
    xp: 15,
  },
  {
    id: "trash_rager",
    label: "🔥 RAGER EPISODE",
    desc: "T'as fait un son à la table. Pas fier. Mais le démon l'était.",
    category: "chaos",
    statMods: { emotion: +15, aggression: +8, discipline: -10, ego: +5 },
    lore: "La salle a entendu. Le démon a existé.",
    xp: 10,
  },
  {
    id: "trash_equipment_blamed",
    label: "🛒 BLAMED THE GEAR",
    desc: "T'as dit que c'était la raquette. Ou les chaussures. Ou la balle. C'était toi.",
    category: "chaos",
    statMods: { ego: +8, adaptation: -6, discipline: -4 },
    lore: "Le démon cherche un coupable ailleurs. Il en trouvera toujours un.",
    xp: 10,
  },

  // ── MYSTICAL EVENTS (rares, gros impact) ──────────────────────────────
  {
    id: "clutch_god",
    label: "👑 CLUTCH GOD",
    desc: "10-10 jeu décisif. T'as gagné les deux derniers points avec des coups que tu referas jamais.",
    category: "mystical",
    statMods: { ego: +15, emotion: +10, creativity: +8, risk: +8, discipline: +5 },
    lore: "Le démon a transcendé. Brièvement. Mais le registre en garde trace.",
    xp: 100,
  },
  {
    id: "nemesis_defeated",
    label: "⚔️ NEMESIS DEFEATED",
    desc: "T'as battu quelqu'un qui te battait systématiquement. La streak est brisée.",
    category: "mystical",
    statMods: { ego: +12, aggression: +8, discipline: +6, emotion: +8 },
    lore: "Le démon a une mémoire longue. Et une liste de comptes à régler.",
    xp: 80,
  },
  {
    id: "setback_overcome",
    label: "🌑→🌕 COMEBACK",
    desc: "T'as remonté un set perdu 2-9. L'adversaire pensait que c'était fini.",
    category: "mystical",
    statMods: { discipline: +12, patience: +10, emotion: +8, ego: +6 },
    lore: "Le démon ne meurt pas. Il attend le bon moment.",
    xp: 90,
  },
  {
    id: "picot_survivor",
    label: "🐸 PICOT SURVIVOR",
    desc: "T'as battu un mec aux picots longues. En lisant ses effets. Sans excuse.",
    category: "mystical",
    statMods: { adaptation: +15, control: +8, ego: +6, chaos: +4 },
    lore: "Les pièges démoniaques ne piègent plus le démon.",
    xp: 75,
  },
  {
    id: "first_tournament_point",
    label: "🏆 PREMIER POINT OFFICIEL",
    desc: "T'as gagné un point dans un match officiel. Le premier ou le centième — il compte.",
    category: "mystical",
    statMods: { ego: +10, discipline: +8, emotion: +6 },
    lore: "Le registre officiel a reconnu l'existence du démon.",
    xp: 70,
  },

  // ── TECHNICAL EVENTS (focus technique) ───────────────────────────────
  {
    id: "third_ball_mastery",
    label: "3️⃣ 3RD BALL MASTER",
    desc: "T'as construit des points sur le 3ème coup intentionnellement pendant toute une session.",
    category: "technical",
    statMods: { discipline: +8, aggression: +6, creativity: +5, control: +4 },
    lore: "Le démon a un plan. Pour la première fois. C'est effrayant.",
    xp: 55,
  },
  {
    id: "placement_click",
    label: "🎯 PLACEMENT PRECISION",
    desc: "T'as visé des zones précises et t'y es allé. Pas par hasard. Par intention.",
    category: "technical",
    statMods: { control: +10, discipline: +7, ego: +4 },
    lore: "La balle va où le démon décide. Pas l'inverse.",
    xp: 50,
  },
  {
    id: "reset_master",
    label: "🔄 RESET KING",
    desc: "T'as neutralisé des top-spins adverses avec des blocs plats ou des amortis. Sans paniquer.",
    category: "technical",
    statMods: { control: +9, patience: +7, adaptation: +6, aggression: -2 },
    lore: "Le démon absorbe ce qui devrait le détruire.",
    xp: 50,
  },
  {
    id: "short_game_mastered",
    label: "🔬 JEU COURT MAÎTRISÉ",
    desc: "T'as forcé 5 erreurs avec des balles courtes dans la même session. Ils ne savaient pas quoi faire.",
    category: "technical",
    statMods: { control: +8, creativity: +7, patience: +5, chaos: +3 },
    lore: "L'espace entre les deux camps appartient maintenant au démon.",
    xp: 55,
  },
  {
    id: "speed_variation",
    label: "🎛️ SPEED VARIATION",
    desc: "T'as intentionnellement varié la vitesse dans un échange et l'adversaire a mordu à chaque fois.",
    category: "technical",
    statMods: { creativity: +9, adaptation: +7, chaos: +5 },
    lore: "Le rythme est une prison. Le démon en tient les clés.",
    xp: 55,
  },

  // ── SOCIAL EVENTS ─────────────────────────────────────────────────────
  {
    id: "learned_from_loss",
    label: "📚 LESSON ABSORBED",
    desc: "T'as perdu mais tu sais exactement ce que t'as appris. T'es presque content.",
    category: "growth",
    statMods: { adaptation: +10, discipline: +7, emotion: -5, ego: -3 },
    lore: "La défaite qui instruit vaut plus que la victoire qui endort.",
    xp: 45,
  },
  {
    id: "taught_someone",
    label: "🎓 SENSEI MOMENT",
    desc: "T'as expliqué un truc à quelqu'un de moins fort. Et en l'expliquant, t'as compris toi-même.",
    category: "growth",
    statMods: { discipline: +8, creativity: +6, ego: +5, control: +4 },
    lore: "Le démon qui transmet devient plus fort.",
    xp: 40,
  },
  {
    id: "table_respect",
    label: "🤝 TABLE RESPECT",
    desc: "T'as eu un bon match avec quelqu'un de fort. Pas gagné. Mais respectueux et intense.",
    category: "growth",
    statMods: { discipline: +7, patience: +6, ego: -3, adaptation: +5 },
    lore: "Le démon reconnaît un autre démon. C'est rare. C'est précieux.",
    xp: 35,
  },
];

// Groupés par catégorie pour l'affichage
export const EVENT_CATEGORIES = {
  growth:    { label:"CROISSANCE",     color:"#4a9e6b", icon:"📈" },
  chaos:     { label:"CHAOS",          color:"#b07fe8", icon:"💥" },
  mystical:  { label:"MYSTIQUE",       color:"#d4a017", icon:"✨" },
  technical: { label:"TECHNIQUE",      color:"#7ecec4", icon:"🎯" },
};

// Noms FR des stats — utilisé dans le panel d'évolution du Journal
export const STAT_NAMES_FR = {
  aggression: "Agressivité", control: "Contrôle", chaos: "Chaos",
  adaptation: "Adaptation",  patience: "Patience",  ego: "Ego",
  creativity: "Créativité",  risk: "Risque",        discipline: "Discipline",
  emotion: "Émotion",
};

// Calcul d'impact — retourne le texte de l'effet
export function describeImpact(statMods) {
  const pos = Object.entries(statMods).filter(([,v]) => v > 0).map(([k,v]) => `${k} +${v}`);
  const neg = Object.entries(statMods).filter(([,v]) => v < 0).map(([k,v]) => `${k} ${v}`);
  return [...pos, ...neg].join(" · ");
}
